// extracted by mini-css-extract-plugin
export default {"rating":"Bz-z","numberOfStars":"Cz-z","count":"Dz-z","barGraphSpacing":"Ez-z","barGraph":"Fz-z"};